import { CdkOverlayOrigin } from "@angular/cdk/overlay";
import { input, Component } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { OpenOrder } from "src/app/models";
import { OrderSourceSystem } from "src/app/models/enums";
import { PopupTooltipComponent } from "src/app/modules/insight-popup-tooltip/components/insight-popup-tooltip/popup-tooltip.component";

@Component({
  selector: 'app-open-orders-view',
  templateUrl: './open-orders-view.component.html',
  styleUrls: ['./open-orders-view.component.scss'],
  imports: [PopupTooltipComponent, CdkOverlayOrigin, MatIcon],
  standalone: true
})
export class OpenOrdersViewComponent {
    public openOrders = input<OpenOrder[]>()
    public dynamicsSourceSystem = OrderSourceSystem.Dynamics;
}